import { makeStyles } from '@mui/styles';
import { Download } from '@tassat/icon';
import React from 'react';

interface DownloadCellRendererProps {
    data: { title: string };
}

const muiStyles = makeStyles({
    icon: {
        marginRight: '10px',
        width: '16px'
    },
    text: {
        color: '#2196F3',
        cursor: 'pointer'
    }
});

export const DownloadCellRenderer = (props: DownloadCellRendererProps) => {
    const { data } = props;
    const classes = muiStyles(props);

    return (
        <>
            <Download
                className={classes.icon}
                iconColor='#757575'
            />
            <span className={classes.text}>{data.title}</span>
        </>
);
};